import { H4 } from "components/ui/typography/titles/Titles"
import { Select } from "components/ui/select/Select"
import type { useCategorySelection } from "hooks/categorySelection.hook"
import style from "./Categories.module.scss"

const { categories, title, selectBlock, selectLabel } = style

const SELECT_CONFIGS = [
	{ label: "Top category", key: "topLevel" },
	{ label: "Super category", key: "super" },
	{ label: "Model category", key: "model" },
] as const

type Props = {
	categorySelection: ReturnType<typeof useCategorySelection>
}

export const Categories = ({ categorySelection }: Props) => {
	const {
		selectedTopLevelCategory,
		selectedSuperCategory,
		selectedModelCategory,
		topLevelOptions,
		superCategoryOptions,
		modelCategoryOptions,
		handleTopLevelChange,
		handleSuperCategoryChange,
		handleModelCategoryChange,
	} = categorySelection

	return (
		<div className={categories}>
			<H4 className={title}>Categories</H4>
			{SELECT_CONFIGS.map(({ label, key }) => {
				const isTopLevel = key === "topLevel"
				const isSuper = key === "super"
				const options = isTopLevel ? topLevelOptions : isSuper ? superCategoryOptions : modelCategoryOptions
				const value = isTopLevel ? selectedTopLevelCategory : isSuper ? selectedSuperCategory : selectedModelCategory

				return (
					<div key={key} className={selectBlock}>
						<span className={selectLabel}>{label}</span>
						<Select
							variant="outlined"
							options={options}
							value={value}
							placeholder="Select category"
							onChange={(newValue) => {
								if (isTopLevel) {
									handleTopLevelChange(newValue)
									return
								}
								if (isSuper) {
									handleSuperCategoryChange(newValue)
									return
								}
								handleModelCategoryChange(newValue)
							}}
							showSearch
							optionFilterProp="label"
						/>
					</div>
				)
			})}
		</div>
	)
}
